import { cn } from '../../lib/cn';

type Props = {
  steps: string[];
  currentStep?: number;
};

export function ConnectionWizardPreview({ steps, currentStep = 0 }: Props) {
  return (
    <ol className="flex flex-wrap gap-2" aria-label="Connection wizard progress">
      {steps.map((label, i) => (
        <li
          key={label}
          aria-current={i === currentStep ? 'step' : undefined}
          className={cn(
            'rounded-full px-3 py-1 text-xs font-medium',
            i === currentStep && 'bg-orange-600 text-white',
            i < currentStep && 'bg-success-100 text-success-800 dark:bg-success-950 dark:text-success-300',
            i > currentStep && 'bg-slate-200 text-slate-600 dark:bg-slate-700 dark:text-slate-400',
          )}
        >
          {label}
        </li>
      ))}
    </ol>
  );
}
